import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class MetaTagsService {
  constructor(public meta: Meta) {}

  get(name) {
    return this.meta.getTag(name);
  }

  updateMetaPropertyAttribute(value, text) {
    this.meta.updateTag({ property: value, content: text });
  }

  updateMetaNameAttribute(value, text) {
    this.meta.updateTag({ name: value, content: text });
  }

  updateMetaTags(meta) {
    for (const key in meta) {
      if (meta.hasOwnProperty(key)) {
        if (key.search(':') > 0) {
          this.updateMetaPropertyAttribute(key, meta[key]);
        } else {
          this.updateMetaNameAttribute(key, meta[key]);
        }
      }
    }
  }
}
